import { factory } from '@store/utils'

export default {
  auto: '*',

  store: {
    getters: {
      articleLaptopFactory: factory(() => ({
        articleId: null,
        authorUserId: null,
        description: null,
        laptopId: null,
        alternativeToLaptopId: null,
        subtitle: null,
        text: null,
        position: null,
        pros: [],
        cons: [],
      })),
    },
  },
}
